import clsx from 'clsx'
import {useInView} from 'react-intersection-observer/useInView'
import convertToSlug from '../../../lib/convert-to-slug'
import {JobOpening} from '../../../types'
import Card from '../../atoms/card'
import Chip from '../../atoms/chip'
import Heading from '../../atoms/heading'
import Link from '../../atoms/link'
import Paragraph from '../../atoms/paragraph'

export interface OpenPositionCardProps {
  /**
   * Data of an open position.
   */
  openPosition: JobOpening
}

export function OpenPositionCard({openPosition}: OpenPositionCardProps) {
  const {ref, inView} = useInView({triggerOnce: true, threshold: 0.35})

  return (
    <Link
      disableDefaultStyles
      href={`/careers/${convertToSlug(openPosition.title)}`}
    >
      <Card
        borderRadius="rounded-2xl md:rounded-3xl"
        className={clsx(
          'w-full grid grid-flow-row gap-4 hover:shadow-card-hover',
          inView
            ? 'motion-safe:animate-fade-in-slide-up-delay-md'
            : 'opacity-0',
        )}
        ref={ref}
      >
        <div>
          <Heading variant="h3" disableMaxWidth>
            {openPosition.title}
          </Heading>

          <Paragraph className="text-typography text-lg w-full">
            {openPosition.shortDescription}
          </Paragraph>
        </div>

        <div className="grid grid-flow-col place-content-start gap-2">
          {openPosition.categories.map(category => (
            <Chip key={category}>{category}</Chip>
          ))}
        </div>
      </Card>
    </Link>
  )
}

export default OpenPositionCard
